// removed by extract-text-webpack-plugin
module.exports = {"TopArea":"AddPinTrd__-loca-__UO-qT","Image":"AddPinTrd__-loca-__2HINH","FileButton":"AddPinTrd__-loca-__iXdqC","LoadingScreen":"AddPinTrd__-loca-__3WA8G","SpinnerLocation":"AddPinTrd__-loca-__muYsA","Show":"AddPinTrd__-loca-__ZvcQF","Hide":"AddPinTrd__-loca-__2p7Zj","Form":"AddPinTrd__-loca-__2_xVO","SpaceBetween":"AddPinTrd__-loca-__2owza","BottomArea":"AddPinTrd__-loca-__2Ctdq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/AddPinTrd/AddPinTrd.css
// module id = 238
// module chunks = 0